import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzRfnd3Nd } from './pages'

type TIdToPageMapWoofzEsa = Record<PageIdWoofzRfnd3Nd, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_RFND3_ND: TIdToPageMapWoofzEsa = {
  [PageIdWoofzRfnd3Nd.SEX_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/DogSexQuestion'
      ).then((m) => ({
        default: m.DogSexQuestionRfnd3Nd,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/questions/DogSexQuestion'),
  },
  [PageIdWoofzRfnd3Nd.DOG_AGE_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/DogAgeQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/questions/DogAgeQuestion'),
  },
  [PageIdWoofzRfnd3Nd.DOG_BREED_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzRfnd3Nd.URGE_RFND3_ND]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePageRfnd,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rfnd3_nd/pages/urge/UrgePage'),
  },
  [PageIdWoofzRfnd3Nd.COMMANDS_61_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/CommandsQuestion61Rfnd'
      ).then((m) => ({
        default: m.CommandsQuestion61Rfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/CommandsQuestion61Rfnd'
      ),
  },
  [PageIdWoofzRfnd3Nd.COMMANDS_62_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/CommandsQuestion62Rfnd'
      ).then((m) => ({
        default: m.CommandsQuestion62Rfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/CommandsQuestion62Rfnd'
      ),
  },
  [PageIdWoofzRfnd3Nd.COMMANDS_63_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/CommandsQuestion63Rfnd'
      ).then((m) => ({
        default: m.CommandsQuestion63Rfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/CommandsQuestion63Rfnd'
      ),
  },
  [PageIdWoofzRfnd3Nd.URGE_RFND3_2_ND]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageRfndVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzRfnd3Nd.POTTY_RFND3_ND]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/questions/PottyQuestion').then(
        (m) => ({
          default: m.PottyQuestionRfnd,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/questions/PottyQuestion'),
  },
  [PageIdWoofzRfnd3Nd.BEHAVIOR_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/BehaviorQuestion'
      ).then((m) => ({
        default: m.BehaviorQuestionRfnd,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/questions/BehaviorQuestion'),
  },
  [PageIdWoofzRfnd3Nd.TRAINING_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/TrainingQuestion'
      ).then((m) => ({
        default: m.TrainingQuestionRfnd,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/questions/TrainingQuestion'),
  },
  [PageIdWoofzRfnd3Nd.PREPARE_FLOW_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/prepare-flow/PrepareFlowRfnd3Nd'
      ).then((m) => ({
        default: m.PrepareFlowRfnd3Nd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/prepare-flow/PrepareFlowRfnd3Nd'
      ),
  },
  [PageIdWoofzRfnd3Nd.DOG_STATISTICS_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/dog-statistics/DogStatisticsRfnd'
      ).then((m) => ({
        default: m.DogStatisticsRfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/questions/dog-statistics/DogStatisticsRfnd'
      ),
  },
  [PageIdWoofzRfnd3Nd.EMAIL_RFND3_ND]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/email/EmailRfnd3').then(
        (m) => ({
          default: m.EmailRfnd3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/email/EmailRfnd3'),
  },
  [PageIdWoofzRfnd3Nd.NEWSLETTER_URGE_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/email/components/NewsletterUrge'
      ).then((m) => ({
        default: m.NewsletterUrge,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/email/components/NewsletterUrge'
      ),
  },
  [PageIdWoofzRfnd3Nd.LAST_CHANCE_OFFER_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/last-chance-offer/LastChanceOfferPageRfnd'
      ).then((m) => ({
        default: m.LastChanceOfferPageRfnd,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/last-chance-offer/LastChanceOfferPageRfnd'
      ),
  },
  [PageIdWoofzRfnd3Nd.SUBSCRIPTIONS_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzRfnd3Nd.CANCEL_OFFER_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/subscriptions/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/subscriptions/CancelOffer'),
  },
  [PageIdWoofzRfnd3Nd.CHAT_UPSELL_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzRfnd3Nd.UPSELL_RFND3_ND]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rfnd3_nd/pages/upsell/Upsell'),
  },
  [PageIdWoofzRfnd3Nd.DOWNLOAD_RFND3_ND]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rfnd3_nd/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rfnd3_nd/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzRfnd3Nd.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
